import { useContext, useEffect, useState } from 'react';
import { UserNotificationsContext } from '../../context/user-notifications/user-notifications';
import { ISharedDialogData } from '../../context/user-notifications/user-notifications.model';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

export const InfoDialog = () => {

  const userNotificationContext = useContext(UserNotificationsContext);

  const [details, setDetails] = useState<ISharedDialogData>({
    active: false,
    title: '',
    message: '',
    buttonCopy: '',
    cancelButtonCopy: '',
    hideCancelButton: false,
    have_form_input: false,
    form_value: ''
  })

  useEffect(() => {
    setDetails(userNotificationContext.dialogDetails)
  }, [userNotificationContext.dialogDetails]);

  const onCancel = () => {
    userNotificationContext.onUserResponse(false);
  };

  const onConfirm = () => {
    userNotificationContext.onUserResponse(true, details.form_value);
  }

  return (
    <Dialog maxWidth='sm' fullWidth open={details.active}>
      <Box sx={{ p: 4 }}>
        <DialogTitle sx={{ pt: 0, pl: 0, pr: 0 }}>
            {details.title}
          {/* <Divider sx={{ mt: 4 }} /> */}
        </DialogTitle>
        {/* <IconButton
          aria-label="close"
          onClick={() => onCancel()}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton> */}
        <DialogContent sx={{ pt: 0, pl: 0, pr: 0 }}>
          {Array.isArray(details.message) ? (
            details.message.map((msg, index) => (
              <Typography key={index} variant="body1" sx={{ mb: 1 }}>
                {msg}
              </Typography>
            ))
          ) : (
            <Typography variant="body1">
              {details.message}
            </Typography>
          )}
          {/* {details.have_form_input && <GaiaTextField
          value={details.form_value}
          charchterCount={25}
          minRows={1}
          formControlName='form_value'
          emitValueOnly={true}
          onChange={(e) => setDetails({ ...details, form_value: e })}>
        </GaiaTextField>} */}

        </DialogContent>
        <DialogActions sx={{ pt: 0, pl: 0, pr: 0 }}>
          <Stack direction='row' sx={{ p: 0 }} spacing={2}>
            {!details.hideCancelButton && <Button variant='text' onClick={() => onCancel()}>
              <Typography sx={{p: 0.5}}>
                {details.cancelButtonCopy || 'Cancel'}
              </Typography>
            </Button>}
            <Button
              variant="contained"
              disableElevation
              disabled={details.have_form_input && !details.form_value}
              onClick={() => onConfirm()}
            >
              <Typography>
                {details.buttonCopy || 'Continue'}
              </Typography>
            </Button>
          </Stack>
        </DialogActions>
      </Box>
    </Dialog >
  )
}